import { Eye } from '@phosphor-icons/react';
import React, { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
function LetterViewModal({ data }) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const CancelButton = () => {
    toggle();
  }
  return (
    <>
      <button onClick={toggle} className="icon-bg-green border-0 p-3 py-3 rounded"><Eye size="30" className='icon-color-green' /></button>
      <Modal className='border-0' isOpen={modal} toggle={toggle} size="lg" centered>
        <ModalHeader className='bg-base-color ' toggle={toggle} ><span className='title-font-700 fs-36 text-base-white'>Letter Of Intent (Header / Footer )</span></ModalHeader>
        <ModalBody className='bg-white px-5 py-5 d-flex justify-content-center flex-column'>
          <header>
            <h2 className="fs-1 text-base-color title-font-bold text-center py-3">Header</h2>
            <div className="d-flex align-items-center justify-content-start gap-5">
              <div className="img-box-logo">
                <img src={data.company_logo} alt="" className='img-fit' />
              </div>
              <div className="">
                <h2 className='fs-2 text-black title-font-800'>{data.name_of_company}</h2>
                <address className='fs-4 text-base-black w-75 mb-0'>{data.company_address}</address>
                <span className='d-flex align-items-center gap-5 mb-2'>
                  <label className='fs-3 text-black'>Tel : {data.contact_number}</label>
                  <label className='fs-3 text-black'>Fax : {data.fax_number}</label>
                </span>
                <h4 className='fs-3 text-black'>Date : {new Date().toLocaleDateString()}</h4>
              </div>

            </div>
          </header>
          <footer>
            <div className="row pt-5">
              <h2 className="fs-1 text-base-color title-font-bold text-center py-3">Footer</h2>
              <div className="d-flex gap-3">
                <label className='fs-3 text-base-black title-font-700 text-nowrap'>
                  Registered Office:
                </label>
                <p className="fs-4 text-base-black base-font-500">{data.register_address}</p>
              </div>
              <div className="d-flex gap-3">
                <label className='fs-3 text-base-black title-font-700 text-nowrap'>
                  Corporate Office:
                </label>
                <p className="fs-4 text-base-black base-font-500">{data.corporate_office}</p>
              </div>
            </div>
          </footer>
        </ModalBody>
        <ModalFooter>
          <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>
        </ModalFooter>
      </Modal>
    </>
  )
};


export default LetterViewModal